import EastIcon from '@mui/icons-material/East';
import { Tab } from '@mui/material';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  InstalacionesAsignadasTecnicoPage,
  InstallAsignadaTecnicoOTByState,
} from '@/erp/tecnico/orden-trabajo/pages';
import {
  EstadosOrdenTrabajoEnumChoice,
  ROUTER_PATHS,
  a11yProps,
  useCheckPermissions,
  useTabsFormOnly,
} from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import { useEffect } from 'react';
import { usePaymentMethodsStore } from '@/store/erp/system-settings/payment-methods';

export const returlUrlAuditoriaInstalacionesPage =
  ROUTER_PATHS.operaciones.auditoriaInstalacionesNav;

export type AuditoriaInstalacionesOTMainPageProps = {};

const AuditoriaInstalacionesOTMainPage: React.FC<
  AuditoriaInstalacionesOTMainPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);

  const { getpaymentMethodsFilterPaging } = usePaymentMethodsStore();
  
  const { handleMethodChange, valueTab } = useTabsFormOnly({initialTabValue:1});
  useEffect(() => {
    getpaymentMethodsFilterPaging()
  }, []);

  return (
    <SingleTableBoxScene title={'Auditoría | Instalaciones'}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Realizadas por Técnico" value={1} {...a11yProps(1)} />
          <Tab label="Actualización Solicitada" value={2} {...a11yProps(2)} />
          <Tab label="Corregidas" value={3} {...a11yProps(3)} />
          <Tab label="Aprobadas" value={4} {...a11yProps(4)} />
          <Tab label="Rechazadas" value={5} {...a11yProps(5)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ REALIZADAS ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <InstalacionesAsignadasTecnicoPage
          stateOT={EstadosOrdenTrabajoEnumChoice.REALIZADA}
          editPath={`${returlUrlAuditoriaInstalacionesPage}/realizadas`}
          editIcon={<EastIcon />}
        />
      </CustomTabPanel>
      {/* ============ ACTUALIZACIÓN SOLICITADA ============ */}
      <CustomTabPanel value={valueTab} index={2}>
        <InstalacionesAsignadasTecnicoPage
          stateOT={EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR}
          editPath={`${returlUrlAuditoriaInstalacionesPage}/realizadas`}
          editIcon={<EastIcon />}
        />
      </CustomTabPanel>
      {/* ============ CORREGIDAS ============ */}
      <CustomTabPanel value={valueTab} index={3}>
        <InstalacionesAsignadasTecnicoPage
          stateOT={EstadosOrdenTrabajoEnumChoice.REALIZADA_ACTUALIZADA}
          editPath={`${returlUrlAuditoriaInstalacionesPage}/realizadas`}
          editIcon={<EastIcon />}
        />
      </CustomTabPanel>
      {/* ============ APROBADAS ============ */}
      <CustomTabPanel value={valueTab} index={4}>
        <InstalacionesAsignadasTecnicoPage
          stateOT={EstadosOrdenTrabajoEnumChoice.REALIZADA_APROBADA}
          editPath={`${returlUrlAuditoriaInstalacionesPage}/realizadas`}
          editIcon={<EastIcon />}
        />
      </CustomTabPanel>

      {/* ============ RECHAZADAS ============ */}
      <CustomTabPanel value={valueTab} index={5}>
        <InstallAsignadaTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.RECHAZADA}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default AuditoriaInstalacionesOTMainPage;
